module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesis-video-media-2017-09-30.paginators.json
// module id = 530
// module chunks = 30